<template>
  <div id="app">
    <layout></layout>

  </div>
</template>

<script>
import Layout from '@/components/layout'
export default {
  name: 'App',
  components: {
    Layout
  }
}
</script>

<style>
  html,body{
    width:100%;
    padding:0;
    margin:0;
    overflow: hidden;
    font-family: "Microsoft YaHei","微软雅黑";
  }
  ul,h3,h4{
    padding:0;
    margin:0;
  }
  ul li{
    list-style: none;
  }
  .el-vue-search-box-container .search-tips {
    max-height: 200px;
    width:100%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue